import cn from "classnames";

export const styles = {
  container: cn(
    "bg-hyam-white",
    "hyam-h-screen-visible w-screen",
    "px-calc-px-sm",
    "md:px-calc-px-md",
    "lg:px-calc-px-lg",
  ),

  header: cn(
    "flex flex-col",
    "justify-center items-center",
    "h-hyam-navbar-h-sm",
    "relative",
  ),

  logo: cn(),
  logo_subheadline: cn(
    "whitespace-nowrap uppercase tracking-[0.12rem] font-medium font-body antialiased text-[0.55rem] mb-0 w-fit mx-auto",
    "absolute",
    "bottom-1",
  ),

  close_button: cn(
    "absolute",
    "cursor-pointer",
    "top-0",
    "h-hyam-navbar-h-sm xl:h-hyam-navbar-h-xl",
    "flex items-center justify-center",
  ),

  panel: cn(
    "absolute",
    "left-0",
    "px-calc-px-sm",
    "md:px-calc-px-md",
    "lg:px-calc-px-lg",
    "hyam-h-menu-panel",
    "w-screen",
    // short screens (landscape): let the list scroll instead of running off
    // the screen, with room below so the last item clears the language switch
    "overflow-y-auto pb-32",
    "flex flex-col",
    "mt-6",
    "items-stretch",
    "bg-hyam-white",
    "transition-opacity",
    "duration-500",
  ),
  panel_inactive: cn(
    "opacity-0",
    "pointer-events-none",
  ),
  panel_item: cn(
    "flex",
    "justify-between",
    "w-full",
  ),
  panel_item_title: cn(),
  panel_item_arrow: cn(),

  panel_back_item: cn(
    "flex",
    "items-center",
    // "justify-between",
    "h-11",
    "mb-7",
  ),
  panel_back_item_button_container: cn(
    "w-full",
    "mr-8",
    "flex justify-center",
  ),
  panel_back_item_button: cn(
    "mb-0",
    "decoration-hyam-black",
    "font-medium",
  ),
  panel_back_arrow: cn(
    "h-11 w-11",
    "-ml-3",
    "flex justify-center items-center",
    "cursor-pointer",
    "self-start",
  ),

  // Full-width strip above the "Book an appointment" bar (about 44px tall).
  // The background keeps menu items that scroll underneath from showing through.
  lang_switch: cn(
    "absolute left-0 z-10 w-screen",
    "px-calc-px-sm md:px-calc-px-md lg:px-calc-px-lg",
    "py-3 bg-hyam-white",
    "bottom-[4.25rem] landscape-mobile:bottom-[3.25rem]",
  ),
};

export const constants = {
  logoHeight: 20,
};

export type HyamPrismicDocumentMenuMobileStyles =
  typeof styles;
